// extracted by mini-css-extract-plugin
module.exports = {"button":"quantity-input_button__ZOs_3","input":"quantity-input_input__aRIP6"};